module.exports = __webpack_public_path__ + "5396d57a3ec6187d3fb9d9aecb1880ef.png";